// @flow
import { connect } from 'react-redux'
import selectorComponent from './selectorComponent'
import { selectorActions } from './reducer'
import type { AppState } from '../../stores/index'

function mapStateToProps ({ categorySelection }: AppState) {
  return {
    selectedFlatSize: categorySelection.flatSize,
    selectedPriceRange: categorySelection.priceRange
  }
}

function mapDispatchToProps (dispatch) {
  return {
    flatSizeChangeHandler: flatSize =>
      dispatch(selectorActions.selector.flatsize.set(flatSize)),
    priceRangeChangeHandler: priceRange =>
      dispatch(selectorActions.selector.pricerange.set(priceRange))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(selectorComponent)
